import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-black/5 bg-[#F2F4F2] pt-14 pb-8 px-6" data-testid="site-footer">
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8">
        {/* Brand */}
        <div className="col-span-2 md:col-span-2 max-w-sm">
          <div className="flex items-center mb-3">
            <img src="/logo-full.png" alt="LIMYA" className="h-8 w-auto" data-testid="footer-logo-image"/>
          </div>
          <p className="text-sm text-[#222]/60 leading-relaxed">
            A neighborhood bulletin board for trusted local pros. Discover, save, and message the people your neighbors already rely on.
          </p>
        </div>

        {/* Explore */}
        <div>
          <h4 className="text-xs font-bold uppercase tracking-wider text-[#222]/45 mb-3">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/upgrade" className="text-[#222]/70 hover:text-[#245544] transition" data-testid="footer-memberships">Memberships</Link></li>
            <li><Link to="/faq" className="text-[#222]/70 hover:text-[#245544] transition" data-testid="footer-faq">FAQ</Link></li>
            <li><Link to="/learn" className="text-[#222]/70 hover:text-[#245544] transition" data-testid="footer-learn">Learn</Link></li>
            <li><Link to="/legal" className="text-[#222]/70 hover:text-[#245544] transition" data-testid="footer-legal">Legal</Link></li>
            <li><Link to="/legal/terms" className="text-[#222]/70 hover:text-[#245544] transition" data-testid="footer-terms">Terms of Use</Link></li>
            <li><Link to="/legal/privacy" className="text-[#222]/70 hover:text-[#245544] transition" data-testid="footer-privacy">Privacy Policy</Link></li>
          </ul>
        </div>

        {/* Company */}
        <div>
          <h4 className="text-xs font-bold uppercase tracking-wider text-[#222]/45 mb-3">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/contact" className="text-[#222]/70 hover:text-[#245544] transition" data-testid="footer-contact">Contact</Link></li>
            <li>
              <Link to="/feedback" className="inline-flex items-center gap-1.5 px-2.5 py-1 -ml-2.5 rounded-full bg-[#FDF4E3] border border-[#E0A83E]/40 text-[#222321] font-semibold hover:bg-[#FBEBCC] transition-colors" data-testid="footer-feedback">
                <MessageCircle size={13} className="text-[#E0A83E]"/> Share Feedback
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-10 pt-6 border-t border-black/5 flex flex-col sm:flex-row justify-between items-center gap-3">
        <span className="text-xs text-[#222]/45">© 2026 LIMYA — A bulletin board for your block.</span>
        <span className="text-xs text-[#222]/45">Made for neighbors, by neighbors.</span>
      </div>
    </footer>
  );
}
